import React from "react";
import { OrderItemWithCurrency } from "../../items-table/hooks";
import { formatPrice } from "@/utils/helpers";

interface Props {
  item: OrderItemWithCurrency;
}

const ItemDetails: React.FC<Props> = ({ item }) => {
  const brandName = item.metadata?.brand_title || null;
  const currency = item.currency_code || "GEL";
  const vintage = item.metadata?.vintage || null;

  const unitPrice = typeof item.unit_price === "number" ? item.unit_price : 0;
  const quantity = typeof item.quantity === "number" ? item.quantity : 0;

  const total = unitPrice * quantity;

  return (
    <div className="space-y-4 text-sm text-gray-800">
      <div className="space-y-4">
        <div className="flex items-start justify-between">
          <span className="text-sm text-gray-500 w-32">Brand</span>
          <span className="text-sm text-gray-900 font-medium">{brandName}</span>
        </div>
        <div className="flex items-start justify-between">
          <span className="text-sm text-gray-500 w-32">Title</span>
          <span className="text-sm text-gray-900 font-medium">
            {item.product_title}
          </span>
        </div>
        <div className="flex items-start justify-between">
          <span className="text-sm text-gray-500 w-32">Vintage</span>
          <span className="text-sm text-gray-900 font-medium">{vintage}</span>
        </div>
        <div className="flex items-start justify-between">
          <span className="text-sm text-gray-500 w-32">Quantity</span>
          <span className="text-sm text-gray-900 font-medium">{quantity}x</span>
        </div>
        <div className="flex items-start justify-between">
          <span className="text-sm text-gray-500 w-32">Unit Price</span>
          <span className="text-sm text-gray-900 font-medium">
            {formatPrice(unitPrice, currency)}
          </span>
        </div>
      </div>

      <div className="border-t pt-4 space-y-2">
        <div className="flex justify-between font-semibold">
          <span>Total</span>
          <span>{formatPrice(total, currency)}</span>
        </div>
      </div>
    </div>
  );
};

export default ItemDetails;
